import { useSyncExternalStore } from 'react';

import { BPMapEditorAPI } from '../map/BPMapAPI';
import { PANEL } from '../types';

/** global panel state */
let initialPanelState = {
  isPanelOpened: false,
  /**
   * opened panel, only one panel allowed to open
   */
  currentPanel: '',
};
// FIXME: pending to use this...
let _map: BPMapEditorAPI;

/**
 * callback functions would dynamically change
 */
let listeners: (() => void)[] = [];

const emitChange = () => {
  for (const listener of listeners) {
    listener();
  }
};

/**
 * Manage side panel & review panel openness state
 * @date 2024/11/01
 */
export const panelOpenStore = {
  isPropsPanelOpen() {
    return initialPanelState.currentPanel == PANEL.S;
  },
  isReviewPanelOpen() {
    return initialPanelState.currentPanel == PANEL.T;
  },
  /**
   * @deprecated no longer in use
   * @param map
   */
  setMapEditor(map: BPMapEditorAPI) {
    _map = map;
  },
  /**
   * open panel
   * @param panelName panel to open
   */
  setPanelOpen(panelName: string) {
    initialPanelState = {
      isPanelOpened: true,
      currentPanel: panelName,
    };
    emitChange();
  },
  /**
   * only close feature selected panel used by `esc` key, or manual closing
   * @returns void
   */
  closeFeaturePanel() {
    const { currentPanel } = initialPanelState;

    // ! check if no panel opened to avoid unnecessary rendering!
    // @2025/09/10
    if (!currentPanel) return;
    // not closing `total review panel`
    if (currentPanel === PANEL.T) return;

    // == update panel store ==
    initialPanelState = {
      isPanelOpened: false,
      currentPanel: '',
    };
    // notify change
    emitChange();
  },
  /**
   * common close current active panel,
   * currently for `review panel` closing!
   */
  setPanelClose() {
    initialPanelState = {
      isPanelOpened: false,
      currentPanel: '',
    };
    emitChange();
  },
  hasPanelOpen() {
    const { isPanelOpened } = initialPanelState;
    return isPanelOpened;
  },
  // == inline method ==
  subscribe(listener: () => void) {
    listeners = [...listeners, listener];
    return () => {
      // remove the newly added listener to achieve unsubscribe
      listeners = listeners.filter((l) => l !== listener);
    };
  },
  /**
   * exposed state change handler for `useSyncExternalStore`
   * @returns an immutable catalogues store state
   */
  getSnapshot() {
    return initialPanelState;
  },
};

/**
 * Check global panel state
 * @returns panel state
 */
export const usePanelOpenStore = () => {
  const { subscribe, getSnapshot } = panelOpenStore;
  const panelState = useSyncExternalStore(subscribe, getSnapshot);

  const checkPanelOpen = (panelName: string) => {
    const { isPanelOpened, currentPanel } = panelState;
    if (!isPanelOpened) return false;
    if (panelName === currentPanel) return true;
    return false;
  };

  return {
    ...panelState,
    checkPanelOpen,
  };
};
